import {Component, OnInit} from '@angular/core';
import {AppService} from '@services/app.service';
import {DateTime} from 'luxon';
import { MatDialog } from '@angular/material/dialog';
import { CambiarPasswordComponent } from '@modules/cambiar-password/cambiar-password.component';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
    public user;

    constructor(
        private appService: AppService,
        public dialog: MatDialog
    ) {
        this.user = this.appService.getProfile();
    }

    ngOnInit(): void {

    }

    logout() {
        this.appService.logout();
    }

    formatDate(date) {
        return DateTime.fromISO(date).toFormat('dd LLL yyyy');
    }

    openChangePasswordDialog() {
        this.dialog.open(CambiarPasswordComponent, {
            minWidth: '400px'
        });
    }
}
